@import "../../../styles/global.scss";

.server-error {
  &__container {
    background-color: white;
    padding: 20px;
    margin: 20px 0px 40px 0px;
    @media (min-width: $tablet) {
      margin: 20px 20px 40px 0;
    }
  }
}
.server-error__title {
  margin-top: 0;
  margin-bottom: 16px;
}

.server-error__description {
  margin-bottom: 0;
}
